export default __webpack_public_path__ + "1.18.19/static/media/libreLinkUp-ar.c2bd9167.svg";